export default __webpack_public_path__ + "static/media/magic-icon.dba9dbbc.svg";